import React, { createContext, useState, useEffect } from 'react';
import Api from "../util/api";
import PropTypes from "prop-types";

const UserContext = createContext();

function UserProvider({ children }) {
    const [stateApp, setStateApp] = useState({
        llave_publica_wallet: null,
        walletConnected: false,
    });

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [user, setUser] = useState();

    useEffect(async () => {
        try {
            const userString = localStorage.getItem("user");
            if (!userString) return;
            const user = JSON.parse(userString);
            if (!user) return;
            const res = await Api.usuarios.get(user._id);
            var data = await res.json();
            setUser(data.usuario);
        } catch (e) {
            console.log(e);
        }

    }, [])

    return (
        <UserContext.Provider value={{ stateApp, setStateApp, user, setUser, showLoginModal, setShowLoginModal }}>
            {children}
        </UserContext.Provider>
    );
}

UserProvider.propTypes = {
    children: PropTypes.func.isRequired,
};

export { UserContext, UserProvider };